const arrayToOptions = (array) => array.reduce((options, item) => {
  options[item] = item;
  return options;
}, {});

export default {
  roles: {
    ROLE_ADMIN: 'Administrator',
    ROLE_MANAGER: 'Manager',
    ROLE_RECRUITER: 'Recruitment manager',
    ROLE_USER: 'Gebruiker'
  },
  drivingLicense: arrayToOptions(['A', 'A1', 'A2', 'AM', 'B', 'BE', 'B+', 'C', 'CE', 'C1', 'C1E', 'D', 'DE', 'D1', 'D1E', 'T']),
  source: {
    website: 'Website',
    'via medewerker': 'Via medewerker',
    anders: 'Anders',
    onbekend: 'Onbekend',
    import: 'Import'
  },
  workdays: { '1': '1', '2': '2', '3': '3', '4': '4', '5': '5', '6': '6' },
  publicTransportCards: {
    'none': 'person.public-transport-none.option',
    'week': 'person.public-transport-week.option',
    'weekend': 'person.public-transport-weekend.option',
  }
};
